export default __webpack_public_path__ + "static/media/esquinero4.9c8a4355.png";